import { useReactiveVar } from '@apollo/client'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core'
import clsx from 'clsx'
import React, { FC, useCallback, useMemo } from 'react'
import { RadioType } from './AddProductTypes'
import {
    addProductDialogState,
    defaultAddProductDialogState,
    setProductDialogState,
} from './addProductFormHandler'
import { useAddProductFormStyles } from './formStyles'

const FamilyRadioSection: FC = () => {
    const { familyRadio, firmName, type, errors } = useReactiveVar(
        addProductDialogState
    )

    const classes = useAddProductFormStyles()

    const isFamilyDisabled = useMemo(() => !firmName, [firmName])

    const handleFamilyRadioChange = useCallback(
        (_, value) => {
            setProductDialogState({
                ...defaultAddProductDialogState,
                productTypeRadio: value,
                type,
                firmName,
                familyRadio: value,
                errors: {
                    firmName: errors.firmName,
                },
            })
        },
        [
            setProductDialogState,
            type,
            firmName,
            errors,
            defaultAddProductDialogState,
        ]
    )

    return (
        <GridItem
            className={clsx(classes.rowContainer, 'rowContainer')}
            data-testid="familyRadio"
            xs={12}
        >
            <RadioGroup
                aria-label="family"
                value={familyRadio}
                name="family"
                row
                onChange={handleFamilyRadioChange}
            >
                <FormControlLabel
                    control={<Radio color="primary" />}
                    value={RadioType.Existing}
                    label="Existing Family"
                    labelPlacement="end"
                    disabled={isFamilyDisabled}
                />
                <FormControlLabel
                    value={RadioType.New}
                    control={<Radio color="primary" />}
                    label="New Family"
                    labelPlacement="end"
                    disabled={isFamilyDisabled}
                />
            </RadioGroup>
        </GridItem>
    )
}

export default FamilyRadioSection
